var _rect, _rect2, _g, _circle, _style, _circle2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIconGenerating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_4569_8458)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4569_8458)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 96,
    height: 96,
    rx: 20,
    fill: "#FFFEFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4569_8458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 96,
    height: 96
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0625,
    y: 13.0625,
    width: 95.875,
    height: 95.875,
    fill: "#D9D9D9",
    stroke: "#FFFEFC",
    strokeWidth: 0.125
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4569_8458)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4569_8458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 96,
    height: 96,
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 96,
    height: 96,
    fill: "url(#paint0_radial_4569_8458)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0625,
    y: 13.0625,
    width: 95.875,
    height: 95.875,
    stroke: "#FFFEFC",
    strokeWidth: 0.125
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 61,
    r: 35.5,
    fill: "#374562",
    fillOpacity: 0.15,
    stroke: "#FFFEFC"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .generating-wedge {\n    transform-origin: 65px 61px;\n    animation: generating-spin 2.4s linear infinite;\n  }\n  @keyframes generating-spin {\n    to { transform: rotate(360deg); }\n  }\n")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "generating-wedge",
    cx: 65,
    cy: 61,
    r: 14.5,
    pathLength: 100,
    fill: "none",
    stroke: "url(#paint1_linear_4569_8458)",
    strokeOpacity: 0.8,
    strokeWidth: 29,
    strokeLinecap: "butt",
    strokeDasharray: "25 75"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12.5,
    width: 97,
    height: 97,
    rx: 20.5,
    stroke: "#FFFEFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_4569_8458",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0509804 0 0 0 0 0.14902 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_8458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_8458",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.996078 0 0 0 0 0.988235 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4569_8458"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4569_8458",
    x: 1.5,
    y: -2.5,
    width: 127,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.75,
    result: "effect1_foregroundBlur_4569_8458"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4569_8458",
    x: 36,
    y: 32,
    width: 58,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_8458"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4569_8458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 13) rotate(45) scale(135.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF94AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#97D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4569_8458",
    x1: 60.7529,
    y1: 32,
    x2: 60.7529,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4569_8458"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 96,
    height: 96,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGenerating);
export default __webpack_public_path__ + "static/media/app-icon-generating.31b0e75cede5c4ccea285334a6decd6e.svg";
export { ForwardRef as ReactComponent };